import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import {
  MotifModalModule,
  MotifButtonModule,
  MotifIconModule,
  ButtonSizes,
  MOTIF_MODAL_DATA,
  MotifModalRef,
} from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { IconoirXmark } from '@ey-xd/motif-icon';
import { DialogData } from '../../../models/dialogData';

@Component({
  selector: 'confirm-dialog',
  imports: [
    CommonModule,
    TranslatePipe,
    TranslateDirective,
    MotifModalModule,
    MotifButtonModule,
    MotifIconModule,
  ],
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  buttonSizes = ButtonSizes;
  closeIcon = IconoirXmark;
  @Input() icon: any = '';
  readonly data = inject<DialogData>(MOTIF_MODAL_DATA);
  @Output() responseEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private readonly dialogRef: MotifModalRef<ConfirmDialogComponent>,
  ) {}

  ok() {
    this.dialogRef.close({ response: true, data: this.data });
  }

  cancel() {
    this.dialogRef.close({ response: false, data: this.data });
  }

  // Strips markup (e.g. <b>) from translated titles so aria-label announces plain text.
  stripHtml(value: string): string {
    if (!value) {
      return '';
    }
    const tmp = document.createElement('div');
    tmp.innerHTML = value;
    return tmp.textContent || tmp.innerText || '';
  }
}
